import { PortfolioIdUtil } from '../utils/portfolio-id.util';


export class PortfolioParamBuilder {
	private identifier: string | number;

	/**
	 * Use this like PortfolioParamBuilder.construct().setIdentifier('test').build()
	 */
	public static construct(): PortfolioParamBuilder {
		return new PortfolioParamBuilder();
	}

	public setIdentifier(identifier: string | number): PortfolioParamBuilder {
		this.identifier = identifier;
		return this;
	}

	public build(): PortfolioParam {
		const portfolioParam = {} as PortfolioParam;
		if (this.identifier) {
			if (PortfolioIdUtil.isBlackRockModel(this.identifier)) {
				portfolioParam.identifier = 'portfolio_id:' + this.identifier;
			} else if (PortfolioIdUtil.isThirdPartyModel(this.identifier.toString())) {
				portfolioParam.identifier = 'third_party_id:' + this.identifier;
			} else {
				portfolioParam.identifier = this.identifier.toString();
			}
		}

		return portfolioParam;
	}
}

export interface PortfolioParam {
	identifier?: string;
}
